/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.rest.client.model

import systems.frictionless.impulse.rest.model.Index

/**
 * Represents a progress through a series of discrete items.
 *
 * @param last Must be greater than [current].
 */
data class Progress(val current: Index, val last: Index) {
    init {
        require(last.value > 0) { "last must be > 0 but was $last" }
        require(last.value >= current.value) { "last ($last) must be >= current ($current)" }
    }

    fun toPercent() = PercentDecimal(current.value.toDouble() / last.value.toDouble())

    companion object {
        val EMPTY = Progress(Index(0), Index(1))
        val COMPLETE = Progress(Index(1), Index(1))
    }
}
